import { actionCreator, ActionReturnType, Loading, loadingNotStarted, loadingIsLoading, loadingFinished, loadingFailed } from "@itk/typescript-utils";
import { NcsColorGet } from "./ncs-colors-types";

export enum Action {
  GetNcsColorsRequest = "@@ITK:SRC:COMPONENTS:NCS-COLORS:NCS-COLORS-STORE.TS:ACTION:GETNCSCOLORSREQUEST",
  GetNcsColorsSuccess = "@@ITK:SRC:COMPONENTS:NCS-COLORS:NCS-COLORS-STORE.TS:ACTION:GETNCSCOLORSSUCCESS",
  GetNcsColorsFailure = "@@ITK:SRC:COMPONENTS:NCS-COLORS:NCS-COLORS-STORE.TS:ACTION:GETNCSCOLORSFAILURE"
}

type NcsColorsState = {
  // the full NCS reference list, fetched once and shared by every NcsColorPicker instance on the page
  ncsColors: Loading<NcsColorGet[]>;
};

const initialState: NcsColorsState = {
  ncsColors: loadingNotStarted
};

export const ncsColorActions = {
  getNcsColorsRequest: () => actionCreator(Action.GetNcsColorsRequest),
  getNcsColorsSuccess: (data: NcsColorGet[]) => actionCreator(Action.GetNcsColorsSuccess, { data }),
  getNcsColorsFailure: () => actionCreator(Action.GetNcsColorsFailure)
};

export const ncsColorsReducer = (state = initialState, action: ActionReturnType<typeof ncsColorActions>): NcsColorsState => {
  switch (action.type) {
    case Action.GetNcsColorsRequest:
      return { ...state, ncsColors: loadingIsLoading };
    case Action.GetNcsColorsSuccess:
      return { ...state, ncsColors: loadingFinished(action.payload.data) };
    case Action.GetNcsColorsFailure:
      return { ...state, ncsColors: loadingFailed };
    default:
      return state;
  }
};
